import React from "react";
import "./App.css";
import Repo from "./Utility/Repo";
import { createContext, useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { MemoizedFooter } from "./Layout/Footer";
import { MemoizedHeader } from "./Layout/Header";
import Body from "./Layout/Body";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "./Components/TokenContext";
import LabelsLoader from "./Utility/labelsLoader";
import BackButtonHandler from "./Components/BackButtonHandler";

function App({ title = "Titolo Predefinito" }) {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);
  const [user, setUser] = useState();

  const [showButton, setShowButton] = useState(false);
  const [userStatus, setUserStatus] = useState(false);
  const [userData, setUserData] = useState(false);
  const [userDataStatus, setUserDataStatus] = useState(true);
  const [userISEEValid, setUserISEEValid] = useState(true);
  const [operator, setOperator] = useState(false);
  const [delegate, setDelegate] = useState(false);
  const [citizen, setCitizen] = useState(false);
  const [subfolder, setSubFolder] = useState(process.env.PUBLIC_URL);

  const labels = LabelsLoader();

  useEffect(() => {
    if (cookies.api_token && !userData) {
      var decoded = jwt_decode(cookies.api_token);
      setUser(decoded.FullName);
      setUserData(true);
    }
    var decoded = {};
    if (apiToken !== undefined) {
      decoded = jwt_decode(apiToken);

      if (decoded.role.includes("OPERATOR")) {
        setOperator(true);
      }

      if (decoded.role.includes("DELEGATE")) {
        setDelegate(true);
        setOperator(false);
      }
      if (decoded.role.includes("CITIZEN")) {
        setCitizen(true);
      }
    }

    if (cookies.user_profile) {
      if (cookies.user_profile.WorkingEntityId) {
        setOperator(true);
      } else if (!userStatus && cookies.api_token) {
        Repo.getUserInfo(apiToken)
          .then((response) => {
            if (!response.data) {
              setUserDataStatus(true);
            } else {
              setUserDataStatus(false);
            }
            setUserStatus(true);
          })
          .catch((error) => {
            setUserDataStatus(false);
            setUserStatus(false);
            console.log(error);
          });
      }
    }
  }, [cookies]);

  let interval;
  useEffect(() => {
    interval = setInterval(() => {
      localStorage.clear();
      window.location.href = subfolder + "/";
    }, 32400000);
  }, [interval]);

  const listaLinkUser = [
    { testo: "Home", url: "/" },
    { testo: "Iscrizioni", url: "/iscrizioni" },
    { testo: "Caricamento ISEE", url: "/caricamento_ISEE" },
    { testo: "Profilo", url: "/profilo" },
    { testo: "Supporto", url: "/supporto" },
  ];

  const listaLinkDelegate = [
    { testo: "Home", url: "/" },
    { testo: "Utenti", url: "/lista_utenti" },
  ];

  const listaLinkOperator = [
    { testo: "Home", url: "/" },
    { testo: "ISEE", url: "/lista_ISEE" },
    { testo: "Utenti", url: "/lista_utenti" },
    { testo: "Pagamenti", url: "/pagamenti" },
    { testo: "Servizi", url: "/servizi" },
    { testo: "Lista Bandi", url: "/lista_bandi" },
    { testo: "Fasce", url: "/fasce" },
    { testo: labels.flussimypay, url: "/flussi_mypay" },
    { testo: "Configurazione", url: "/configurazione" },
  ];
  const listaLink = [{ testo: "Home", url: "/" }];

  const returnlink = () => {
    if (delegate) {
      return listaLinkDelegate;
    } else if (operator) {
      return listaLinkOperator;
    } else if (citizen) {
      return listaLinkUser;
    } else {
      return listaLink;
    }
  };

  useEffect(() => {
    const handleScrollButtonVisibility = () => {
      window.pageYOffset > 300 ? setShowButton(true) : setShowButton(false);
    };

    window.addEventListener("scroll", handleScrollButtonVisibility);

    return () => {
      window.removeEventListener("scroll", handleScrollButtonVisibility);
    };
  }, []);

  return (
    <div className="App">
      {showButton && (
        <a className="backToTop" onClick={() => window.scrollTo(0, 0)}>
          <svg style={{ marginTop: "8px" }} className="icon icon-white">
            <use href={`${iconSprite}#it-arrow-up`}></use>
          </svg>
        </a>
      )}
      <TokenContext.Provider value={apiToken}>
      <BackButtonHandler />
        <Router {...(subfolder && { basename: subfolder })}>
          <div className="headerCustom">
            <MemoizedHeader
              Name={user}
              url="https://www.comune.bari.it/"
              Title={labels.titolo}
              links={returnlink()}
              subfolder={subfolder ? subfolder : ""}
            />
          </div>
          <Body
            userDataStatus={userDataStatus}
            subfolder={subfolder ? subfolder : ""}
          ></Body>
          <MemoizedFooter> </MemoizedFooter>
        </Router>
      </TokenContext.Provider>
    </div>
  );
}

export default App;
